<template>
  <div class="slots">
    <h4>Next Available</h4>
    <div class="alert alert-light bg-light border">
      <div class="row justify-content-center">
        <div class="col-6 col-sm-3 col-lg-2 text-center" v-if="isProfileVisible">
          <img v-bind:src="s.provider.image_url" class="img-fluid rounded-circle mb-3 mb-sm-0 border" width="200" height="200" alt="provider picture" />
        </div>
        <div class="col-12" v-bind:class="{ 'col-sm-9 col-lg-10': isProfileVisible }">
          <div class="d-inline-block">
            <h5 class="d-inline mr-3 mb-1">{{ s.provider.name || "Example Name" }}</h5>
            <strong class="text-nowrap" v-if="s.provider.qualifications != null">{{ s.provider.qualifications }}</strong>
            <table>
              <tbody>
                <tr v-if="s.provider.location != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width:100px;">Location</th>
                  <td>{{ s.provider.location }}</td>
                </tr>
                <tr v-if="isProfileVisible && s.provider.specialty != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width:100px;">Specialty</th>
                  <td>{{ s.provider.specialty }}</td>
                </tr>
                <tr v-if="isProfileVisible && s.provider.services != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width:100px;">Services</th>
                  <td>{{ s.provider.services.join(", ") }}</td>
                </tr>
                <tr v-if="isProfileVisible && s.provider.bio != null">
                  <th class="text-muted align-top font-weight-normal" style="min-width:100px;">Bio</th>
                  <td>{{ s.provider.bio }}</td>
                </tr>
              </tbody>
            </table>
            <button class="btn btn-link p-0 w-auto" v-on:click="isProfileVisible = !isProfileVisible" v-if="!isProfileVisible">
              More
              <i class="fa fa-caret-down"></i>
            </button>
          </div>
          <a href="#" class="btn btn-lg btn-primary js-time float-right w-auto" @click.prevent="$emit('choose', [s])">
            {{ s.label }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "NextAvailable",
  props: ["s"],
  data() {
    return {
      isProfileVisible: false,
    };
  },
  methods: {
    toggleProfileVisibility() {
      this.isProfileVisible = !this.isProfileVisible;
    },
  },
};
</script>
